{
  "alert": "Teade",
  "dismiss": "Lõpeta"
}
